import React from "react";
import {
  PriceBox,
  NameBox,
  AnchorLink,
} from "../../../../components/molecules";
import { Title } from "../../../../components/atoms";
import { Grid, Stack } from "@mui/material";

export const OrderDeliveryDetailRow = ({
  customerName,
  orderValue,
  orderDate,
  orderRef,
  collectedOn,
  productUrl,
}) => {
  return (
    <>
      <div className="for-shipment-landscape">
        <Grid container spacing={2}>
          <Grid item md={3}>
            <PriceBox topText={"Order Ref"} bottomText={orderRef} />
          </Grid>
          <Grid item md={3}>
            <NameBox name={customerName} heading="Customer Name" />
          </Grid>
          <Grid item md={3}>
          <PriceBox topText={"Order Value"}  bottomText={`\u00A3${orderValue}`} />
          </Grid>
          <Grid item md={3}>
            <PriceBox topText={"Order Date"} bottomText={orderDate} />
          </Grid>
          <Grid item md={3}>
          <PriceBox
              topText={"Collected on"}
              bottomText={collectedOn || "N/A"}
            />
          </Grid>
          <Grid item md={4}>
            <div className="align-row-order">
              <div className="product-url-div">
                <Title text={"Cricket Store"} className={"topText"} />
                <AnchorLink text={"View product"} url={productUrl} />
              </div>
            </div>
          </Grid>
        </Grid>
        
      </div>
    </>
  );
};
